const TAG_NAME = 'shopify-payment-terms';

const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  .font-sans {
    font-family: Figtree, var(--font-paragraph--family);
  }
`);

/** @type {WeakSet<ShadowRoot>} */
const observedRoots = new WeakSet();

/**
 * @param {ShadowRoot} root
 */
function adoptStylesheet(root) {
  if (root.adoptedStyleSheets.includes(stylesheet)) return;
  root.adoptedStyleSheets = [...root.adoptedStyleSheets, stylesheet];
}

/**
 * @param {Element} element
 */
function styleElement(element) {
  const root = element.shadowRoot;
  if (!root) return;

  adoptStylesheet(root);

  if (observedRoots.has(root)) return;
  observedRoots.add(root);
  new MutationObserver(() => adoptStylesheet(root)).observe(root, { childList: true, subtree: true });
}

/**
 * @param {ParentNode} scope
 */
function styleAll(scope) {
  scope.querySelectorAll(TAG_NAME).forEach(styleElement);
}

customElements.whenDefined(TAG_NAME).then(() => {
  styleAll(document);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.localName === TAG_NAME) styleElement(node);
        styleAll(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
});
